export default function init() {
  const el = document.getElementById("locSubNav")

  if (el)
    import(/* webpackChunkName: "location-subnavigation" */ "./subnavigation").then(
      ({ default: Subnavigation }) =>
        new Subnavigation(el, {
          mq: "only screen and (max-width: 48em)",
        }).init(),
    )

  return null
}
